<template>
  <div :class="['content',{'area':area}]">
    <div class="content-f">
        <span>{{ite.appName}}</span>
        <span class="concern isChoose" @click.stop="clickFollow(true)" v-show="!isFollow"> + 关注</span>
        <span class="concern" @click.stop="clickFollow(false)" v-show="isFollow"> 取消关注</span>
    </div>
    <span class="related-articles-text-content" v-if="area">{{ite.intro}}</span>
    <div class="content-s">
        <div class="content-s-l">
        <img :src="ite.userLogoUrl" alt="">
        <span>{{ite.trueName}}</span>
        </div>
        <div class="content-s-r">
        <span title="粉丝"><i class="iconfont icon-qunzuxianxing"></i>{{bFans}}</span>
        <span title="关注"><i class="iconfont icon-xinxianxing"></i>{{ite.follow}}</span>
        </div>
    </div>
    </div>
</template>
 
<script>
export default {
  name: 'ChildComponent',
  data(){
    return{
        concernOrn:true,
        bFans:Number(this.ite.bFans),
        isFollow:this.ite.isFollow
    }
  },
  props:{
    ite:Object,
    userId:String,
    pfId:String,
    area:Boolean
  },
  created(){

  },
  watch:{
    'ite':function(val){
      this.bFans = Number(val.bFans);
      this.isFollow = val.isFollow
    }
  },
  methods:{
    fetch(params) {
      return new Promise((resolve, reject) => {
        $.ajax({
          ...params,
          success: function (result) {
            resolve(result);
          },
          error: function () {
            
          }
        })
      })
    },
    clickFollow(state){
        if (!this.$store.state.userInfo.userId) {
          this.handleLoginAuth();
          return;
        }
        this.bFans += state ? 1 : (this.bFans >0 ? -1 : 0);
        this.isFollow = state;
        this.fetch({
          url:'/zciid-deliverable/api/app/followers/flow/user',
          type:'GET',
          data:{
            userId:this.ite.userId,
            fansId:this.userId,
            types: state ? 1 : 0
          }
        })
    }
  }
}
</script>
<style scoped>
  .content {
      padding: 8px 12px 14px;
      background-color: #fafafa;
      border-radius: 0 0 2px 2px;

  }
  .content div{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .content .content-f{
    font-size: 14px;
    color: #333;
  }
  .content .content-f .concern{
    display: inline-block;
    height: 20px;
    border: 1px solid #666;
    border-radius: 13px;
    color: #666;
    padding: 3px 10px;
    cursor: pointer;
    flex-shrink: 0;
  }
  .content .content-f span:first-child{
    max-width: 120px;
    display: inline-block;
  }
  .content .concern.isChoose{
    color: #2f8eed;
    background-color: #e5f2ff;
    border: 1px solid #2f8eed;
  }
  .content .content-s{
    font-size: 12px;
    color: #333;
    margin-top: 5px;
  }
  .content .content-s .content-s-l{
    max-width: 120px;
  }
  .content .content-s .content-s-l img{
    width: 22px;
    height: 22px;
    border-radius: 11px;
    margin-right: 6px;
  }
  .content .content-s .content-s-r span{
    margin-left: 5px;
    cursor: pointer;
  }
  .content .content-s .content-s-r .iconfont{
    font-size: 12px !important;
    margin-right: 3px;
  }
  .content.area .content-f span:first-child{
    font-size: 18px;
    max-width: 200px;
  }
  .related-articles-text-content{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-wrap: break-word;
    color:#333;
    height:38px;
    font-size: 14px;
  }
</style>


// WEBPACK FOOTER //
// src/components/followMembers.vue